import React from "react";

const CourseTitle: React.FC = ({ children }) => {
  return (
    <h1 className="font-bold text-zur-primary text-left text-3xl md:text-5xl mb-4">{children}</h1>
  );
};

export default CourseTitle;
